import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { LeadService } from 'src/app/private/services/lead.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { TrackingService } from 'src/app/private/services/tracking.service';
import {
  formatLeadFieldIsoDate,
  startOfTodayLocal,
} from 'src/app/utils/lead-field-date.util';

@Component({
  selector: 'app-add-communication-log',
  templateUrl: './add-communication-log.component.html',
  styleUrls: ['./add-communication-log.component.scss']
})
export class AddCommunicationLogComponent implements OnInit {
  isSubmitted = false;
  btnLoading = false;
  setupFollowUpReminder = false;
  todayDate: string = formatLeadFieldIsoDate(startOfTodayLocal());

  @Output() close = new EventEmitter<void>();
  @Output() reload = new EventEmitter<void>();
  @Output() openFollowUp = new EventEmitter<any>();
  @Input() leadData: any;
  @Input() isReminderMode: boolean = false;

  notification_date: string = '';
  next_action: string = '';
  remarkValue: string = '';
  isReminderChecked: boolean = false;
  isCron: string = 'True';

  communicationData: any = {
    communication_type: '',
    note: '',
    date_of_communication: '',
    time_of_communication: '',
    status: '',
    call_extra_details: {
      duration: '',
    },
    email_extra_details: {}
  };

  constructor(
    private toast: ToastrService,
    private api: LeadService,
    private localStorageService: LocalStorageService,
    private tracker: TrackingService
  ) {}

  ngOnInit() {
    this.todayDate = formatLeadFieldIsoDate(startOfTodayLocal());

    if (this.isReminderMode) {
      this.communicationData.communication_type = 'call';
      const now = new Date();
      this.communicationData.date_of_communication = this.todayDate;
      this.communicationData.time_of_communication = now.toTimeString().split(' ')[0].slice(0, 5);
    }
  }

  isPastActivityDate(): boolean {
    const date = this.communicationData.date_of_communication;
    if (!date) {
      return false;
    }
    return date < this.todayDate;
  }

  submitForm() {
    this.isSubmitted = true;

    if (
      !this.communicationData.communication_type ||
      !this.communicationData.status
    ) {
      this.toast.error('Please fill in all required fields');
      return;
    }

    if (!this.communicationData.date_of_communication) {
      this.communicationData.date_of_communication = this.todayDate;
    }

    if (this.isPastActivityDate()) {
      this.toast.error('Activity date cannot be in the past');
      return;
    }

    if (!this.communicationData.time_of_communication) {
      const now = new Date();
      this.communicationData.time_of_communication = now.toTimeString().split(' ')[0].slice(0, 5);
    }

    if (this.setupFollowUpReminder) {
      if (this.isReminderChecked && !this.notification_date && this.isCron === 'True') {
        this.toast.error('Please add notification reminder date');
        return;
      }
      if (!this.next_action) {
        this.toast.error('Please add next action');
        return;
      }
      if (!this.remarkValue) {
        this.toast.error('Please add text in update detail');
        return;
      }
    }

    if (this.communicationData.communication_type === 'call') {
      if (!this.communicationData.call_extra_details.duration) {
        this.toast.error('Please provide call duration');
        return;
      }
      this.communicationData.call_extra_details = {
        duration: this.communicationData.call_extra_details.duration,
      };
    } else if (this.communicationData.communication_type === 'email') {
      this.communicationData.email_extra_details = {};
    }

    this.communicationData.lead_id = this.leadData.lead_id;
    this.communicationData.client_id = this.localStorageService.getClientId();
    this.communicationData.center_id = this.localStorageService.getCenterId();
    this.communicationData.user_id = this.localStorageService.getUserId();

    this.btnLoading = true;

    this.api.CreateCommunicationHisLog(this.communicationData).subscribe({
      next: () => {
        this.toast.success('Communication log added successfully');

        const desc = `Communication log added for lead ID: ${this.communicationData.lead_id} | Type: ${this.communicationData.communication_type} | Status: ${this.communicationData.status} | Date: ${this.communicationData.date_of_communication}`;
        this.tracker.track('Create', 'Communication Log', desc);

        if (this.setupFollowUpReminder) {
          this.createFollowUp();
        } else {
          this.btnLoading = false;
          this.reload.emit();
          this.closeModal();
        }
      },
      error: () => {
        this.btnLoading = false;
        this.toast.error('An error occurred while adding the log');
      }
    });
  }

  closeModal() {
    this.close.emit();
  }

  createFollowUp() {
    const followUpData = {
      lead_id: this.leadData.lead_id,
      client_id: this.localStorageService.getClientId(),
      center_id: this.localStorageService.getCenterId(),
      user_id: this.localStorageService.getUserId(),
      remarks: this.remarkValue,
      next_action: this.next_action,
      notification_date: this.notification_date === '' ? null : this.notification_date,
      time: new Date().toTimeString().split(' ')[0].slice(0, 5),
      date: this.todayDate,
      updated_by: {
        email: this.localStorageService.getEmail()
      }
    };

    this.api.addLeadFollowUp(followUpData).subscribe({
      next: () => {
        this.btnLoading = false;
        this.toast.success('Follow-up reminder added successfully');
        this.reload.emit();
        this.closeModal();
      },
      error: () => {
        this.btnLoading = false;
        this.toast.error('Error adding follow-up reminder');
      }
    });
  }

  fnCheckNotificationDate(event: any) {
    this.isReminderChecked = event.target.checked;
    if (this.isReminderChecked == false) {
      this.notification_date = '';
    }
  }
}
